import React, { useMemo, useState } from 'react';
import { SelectField, Button } from '@dopomogai/ui';
import { useSecrets } from '@dopomogai/agent-kit';

export interface SecretTokenPickerProps {
  onInsert: (token: string) => void;
}

export const SecretTokenPicker: React.FC<SecretTokenPickerProps> = ({ onInsert }) => {
  const { secrets, isLoading } = useSecrets();
  const [selected, setSelected] = useState<string>('');

  const options = useMemo(
    () => (secrets || []).map(s => ({ value: s.name, label: s.name })),
    [secrets]
  );

  const insert = () => {
    if (selected) {
      onInsert(`\${secret:${selected}}`);
      setSelected('');
    }
  };

  return (
    <div className="flex items-end gap-2">
      <div className="min-w-[200px]">
        <SelectField
          label="Insert secret"
          name="insert-secret"
          value={selected}
          onChange={(v) => setSelected(String(v))}
          options={options}
          placeholder={isLoading ? 'Loading…' : 'Select secret'}
          disabled={isLoading}
        />
      </div>
      <Button variant="secondary" size="sm" onClick={insert} disabled={!selected}>
        Insert
      </Button>
    </div>
  );
};

export default SecretTokenPicker;

